import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgl/fjxx/'
const SECENE_PRIFIX = 'fpgl/mbxx/'
const additionalInfoConfig: RequestConfig = {
  // 删除附件基本信息
  delJbxxFjxx: {
    url: `${PRIFIX}delJbxxFjxx`,
    method: 'post'
  },
  // 获取附件基本信息
  getJbxxFjxx: {
    url: `${PRIFIX}getJbxxFjxx`,
    method: 'get'
  },
  // 附件基本信息列表
  jbxxFjxxList: {
    url: `${PRIFIX}jbxxFjxxList`,
    method: 'post'
  },
  // 添加或者更新附件信息
  saveOrUpdateFjxx: {
    url: `${PRIFIX}saveOrUpdateFjxx`,
    method: 'post'
  },
  // 附加信息下载
  jbxxFjxxDownload: {
    url: `${PRIFIX}jbxxFjxxDownload`,
    method: 'post'
  },
  // 删除场景模板基本信息
  delJbxxMbxx: {
    url: `${SECENE_PRIFIX}delJbxxMbxx`,
    method: 'post'
  },
  // 获取场景模板基本信息
  getJbxxMbxx: {
    url: `${SECENE_PRIFIX}getJbxxMbxx`,
    method: 'get'
  },
  // 附件场景模板基本信息列表
  jbxxMbxxList: {
    url: `${SECENE_PRIFIX}jbxxMbxxList`,
    method: 'post'
  },
  // 添加或者更新场景模板信息
  saveOrUpdateMbxx: {
    url: `${SECENE_PRIFIX}saveOrUpdateMbxx`,
    method: 'post'
  },
  // 附加信息模板下载
  jbxxMbDownload: {
    url: `${SECENE_PRIFIX}jbxxMbDownload`,
    method: 'post'
  }
}
export default additionalInfoConfig
